export default "__VITE_ASSET__Lc9_uEOw__"